import {MarketmakerStockItem} from '@/types/types'

const STORAGE_KEY = 'MOG_MM_STOCK_CATALOGUE'

export interface StockCatalogueEntry {
  img?: string
  icon_img?: string
  description?: string
}

type Catalogue = {[key: string]: StockCatalogueEntry}

export const stockCatalogueKey = (
  sourceType: string,
  refId: number | null | undefined
) => `${sourceType}:${refId ?? null}`

let cache: Catalogue | null = null

const read = (): Catalogue => {
  if (cache) return cache
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : {}
    cache = parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    cache = {}
  }
  return cache as Catalogue
}

export const rememberStockItems = (stock: MarketmakerStockItem[]) => {
  if (!Array.isArray(stock) || stock.length === 0) return

  const catalogue = read()
  let changed = false

  stock.forEach((item) => {
    if (!item?.source_type) return
    const key = stockCatalogueKey(item.source_type, item.ref_id)
    const next: StockCatalogueEntry = {
      img: item.img || undefined,
      icon_img: item.icon_img || undefined,
      description: item.description || undefined,
    }
    const prev = catalogue[key]
    if (
      prev?.img === next.img &&
      prev?.icon_img === next.icon_img &&
      prev?.description === next.description
    ) {
      return
    }
    catalogue[key] = next
    changed = true
  })

  if (!changed) return

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(catalogue))
  } catch {}
}

export const stockCatalogueEntry = (
  sourceType: string,
  refId: number | null | undefined
): StockCatalogueEntry | undefined =>
  read()[stockCatalogueKey(sourceType, refId)]
